import React from 'react';
import classNames from 'classnames';
import Chart from '@/business-components/chart';
import DataCard from '@/business-components/dataCard';
import Tooltip from '@/components/tooltip';
import Vector from 'assets/vector.svg';
import Hot from 'assets/hot.svg';
import Rate from 'assets/rate.svg';
import styles from './index.module.scss';

export default function Competitiveness({ data }) {
  return (
    <Chart
      title={
        <span className={styles.title}>
          产品信息
          <Tooltip
            title={
              <>
                <p>产品数量通过品牌官方旗舰店的产品数量统计得出。</p>
                <p>数据来源：CBNData数据库</p>
                <p>热门单品数量占比是指每月品牌单品在行业销售额排名TOP1000单品中的数量占比。</p>
                <p>数据来源：任拓情报通</p>
                <p>热门单品销售额占比是指品牌热门单品销售额在品牌整体销售额中的占比。</p>
                <p>数据来源：任拓情报通</p>
              </>
            }
            placement="right"
          />
        </span>
      }
      panelClassName={styles.potentialChart}
    >
      <div className={classNames('flex-row-nowrap', 'flex-start-center', styles.potential)}>
        {data?.map((item, index) => (
          <DataCard
            key={index}
            brandName={item?.chName}
            indicatorData={[
              {
                indicatorName: (
                  <div className={classNames('flex-row-nowrap', 'flex-start-center')}>
                    <Vector />
                    <span style={{ marginLeft: '6px' }}>产品数量</span>
                  </div>
                ),
                indicatorNum: item?.productNum,
              },
              {
                indicatorName: (
                  <div className={classNames('flex-row-nowrap', 'flex-start-center')}>
                    <Hot />
                    <span style={{ marginLeft: '6px' }}>热门单品数量占比</span>
                  </div>
                ),
                indicatorNum: item?.hotRate,
                indicatorUnit: '%',
              },
              {
                indicatorName: (
                  <div className={classNames('flex-row-nowrap', 'flex-start-center')}>
                    <Rate />
                    <span style={{ marginLeft: '6px' }}>热门单品销售额占比</span>
                  </div>
                ),
                indicatorNum: item?.hotSalesVolumeRate,
                indicatorUnit: '%',
              },
            ]}
            className={styles.cardItem}
          />
        ))}
      </div>
    </Chart>
  );
}
